import React from 'react';
const RefundPolicy = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold mb-4">Cancellation & Refund Policy</h1>
    <p>All sales are final as digital products are non-returnable. If you face any issues, please contact us for resolution.</p>
  </div>
);
export default RefundPolicy;
